export default {"src":"/_next/static/media/megaBank.b7fb0888.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};